import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.0.8_@babel+core@7.29.0_@opentelemetry+api@1.9.1_react-dom@19.0.0-rc-66855b96-20_82ae4557b6fcb3dbeed45bb8ba63f14b/node_modules/next/dist/client/link.js");
